import { render } from "./PublicationAiAppFinalReviewUploadSources.vue?vue&type=template&id=f9ebf98e&lang=true"
import script from "./PublicationAiAppFinalReviewUploadSources.vue?vue&type=script&lang=js"
export * from "./PublicationAiAppFinalReviewUploadSources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__